// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".place[data-v-a4e13dd6] {\n  --magic-box-background: var(--magic-tertiary, #311261);\n}\n\n.text[data-v-a4e13dd6] {\n  color: var(--magic-light, #fff);\n  font-weight: 700;\n}\n.text--points[data-v-a4e13dd6] {\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
